/*
  Scart - Signal de déduplication des purchases GA4.

  Problème : pour les commandes où le consentement analytics est accordé
  (auto-grant hors UE/Brésil, ou clic "Accepter" en UE/BR), le Web Pixel Google
  émet un `purchase` côté client sur la page de confirmation Shopify. Le webhook
  server-side (ga4-webhook) émet AUSSI un `purchase` via Measurement Protocol pour
  100 % des commandes. GA4 ne déduplique pas les purchases à l'ingestion (mythe
  hérité d'Universal Analytics) -> double comptage des ventes consenties.

  Fix : quand le consentement analytics est accordé (donc le pixel front VA compter),
  on marque le panier avec l'attribut privé `_ga_cs=1`. Le webhook lit cet attribut
  dans order.note_attributes et SKIP son envoi GA4. Consentement refusé -> pas
  d'attribut -> le webhook reste la seule source (couverture 100 %, attribution nulle
  mais vente comptée).

  Le préfixe `_` rend l'attribut privé : invisible dans le récap commande client,
  mais bien présent dans note_attributes via API/webhook.
*/
(function () {
  var SS_KEY = 'scart_ga_cs';

  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed() === true;
      }
    } catch (e) {}
    // Fallback : le cookie _ga n'est posé que si gtag a été chargé (consent accordé).
    return /(?:^|;\s*)_ga=/.test(document.cookie);
  }

  function markCart() {
    if (!analyticsAllowed()) return;
    try { if (sessionStorage.getItem(SS_KEY) === '1') return; } catch (e) {}
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _ga_cs: '1' } })
    }).then(function () {
      try { sessionStorage.setItem(SS_KEY, '1'); } catch (e) {}
    }).catch(function () {});
  }

  // 1) Au chargement : petit retry le temps que customerPrivacy soit prêt
  //    (auto-grant hors UE -> dispo presque tout de suite).
  var tries = 0;
  (function attempt() {
    if (analyticsAllowed()) { markCart(); return; }
    if (++tries <= 15) setTimeout(attempt, 200);
  })();

  // 2) Si le consentement change en cours de session (clic "Accepter" UE/BR),
  //    Shopify émet `visitorConsentCollected` -> (re)marquer le panier.
  document.addEventListener('visitorConsentCollected', markCart);
})();
